/* eslint-disable max-len */
// Services catalogue content (categories + "Création de contenu"), merged into dictionaries.

export const servicesContent = {
  fr: {
    offres: {
      subtitle: "Quatre expertises complémentaires, déclinées en plusieurs niveaux d'accompagnement, pour construire, valoriser et faire rayonner votre marque.",
      customNote: "Parce que chaque projet est unique, nos signatures peuvent être adaptées à vos besoins. Un accompagnement personnalisé peut également être imaginé sur devis, selon vos objectifs et la complexité de votre projet.",
    },
    categories: {
      branding: { label: "Identité visuelle & Branding", desc: "Logo, palette, typographies : une identité qui vous ressemble." },
      print: { label: "Création Print & Supports de communication", desc: "Flyers, cartes, affiches, documents et présentations : vos supports, pensés pour votre marque." },
      contenu: { label: "Création de contenu", desc: "Des créations photo et vidéo pensées pour raconter votre histoire, capturer votre univers et valoriser votre image." },
      "reseaux-sociaux": { label: "Social Media Management", desc: "Stratégie éditoriale, gestion, planification, publication et suivi des performances de vos réseaux sociaux." },
    },
    documentsTitle: "Documents & présentations",
    contenu: {
      or: "ou",
      disclaimer: "Chaque offre peut être adaptée à vos besoins. Les tarifs sont indiqués à partir de et peuvent varier selon la complexité de la production.",
      cta: "Demander un devis personnalisé",
      signatures: [
        {
          subtitle: "Un instant capturé, une histoire racontée.",
          startPrice: "À partir de 300 €",
          choiceTitle: "Au choix",
          choices: ["1 Reel vidéo (1 min max)", "Mini-séance photo : 5 photos retouchées"],
          includedTitle: "Inclus",
          items: ["Brief créatif", "Tournage vidéo ou séance photo", "Montage professionnel ou retouches photo", "Musique, textes et transitions", "1 série de modifications", "Livraison des contenus prêts à l'emploi"],
        },
        {
          subtitle: "Des contenus qui donnent vie à votre identité.",
          startPrice: "À partir de 700 €",
          choiceTitle: "Au choix",
          choices: ["4 Reels vidéo (1 min max chacun)", "2 Reels vidéo (1 min max) + 10 photos retouchées", "Séance photo : 20 photos retouchées"],
          includedTitle: "Inclus",
          items: ["Brief créatif et direction créative", "Tournage et/ou séance photo", "Montage vidéo et retouches photo", "Harmonisation avec l'identité de la marque", "1 série de modifications", "Livraison des contenus prêts à l'emploi"],
        },
        {
          subtitle: "Une collection de contenus pour affirmer votre univers.",
          startPrice: "À partir de 1 390 €",
          choiceTitle: "Au choix",
          choices: ["8 Reels vidéo (1 min 30 max chacun)", "4 Reels vidéo + 20 photos retouchées", "Production mixte photo & vidéo, définie sur devis"],
          includedTitle: "Inclus",
          items: ["Échange stratégique et direction artistique", "Session de tournage et/ou séance photo", "Montage vidéo et retouches photo", "Cohérence esthétique avec votre univers", "2 séries de modifications", "Livraison de l'ensemble des contenus"],
        },
        {
          subtitle: "Une production imaginée autour de vos ambitions.",
          startPrice: "Sur devis",
          choiceTitle: "Prestations possibles",
          options: ["Vidéos promotionnelles et publicitaires", "Shootings photo professionnels", "Couverture photo et vidéo d'événements", "Campagnes de lancement", "Création régulière de contenus"],
          includedTitle: "Inclus selon le projet",
          items: ["Direction artistique personnalisée", "Organisation des tournages et shootings", "Production photo et/ou vidéo", "Montage et postproduction", "3 séries de modifications"],
        },
      ],
    },
  },
  en: {
    offres: {
      subtitle: "Four complementary areas of expertise, offered in several levels of support, to build, enhance and showcase your brand.",
      customNote: "Because every project is unique, our signatures can be adapted to your needs. Tailored support can also be designed on quotation, according to your goals and the complexity of your project.",
    },
    categories: {
      branding: { label: "Visual Identity & Branding", desc: "Logo, palette, typography: an identity that reflects who you are." },
      print: { label: "Print & Communication Materials", desc: "Flyers, cards, posters, documents and presentations: your materials, designed for your brand." },
      contenu: { label: "Content Creation", desc: "Photo and video creations designed to tell your story, capture your world and enhance your image." },
      "reseaux-sociaux": { label: "Social Media Management", desc: "Editorial strategy, management, scheduling, publishing and performance tracking for your social networks." },
    },
    documentsTitle: "Documents & presentations",
    contenu: {
      or: "or",
      disclaimer: "Every offer can be adapted to your needs. Prices are starting prices and may vary depending on the complexity of the production.",
      cta: "Request a personalised quote",
      signatures: [
        {
          subtitle: "A moment captured, a story told.",
          startPrice: "From €300",
          choiceTitle: "Your choice",
          choices: ["1 video Reel (up to 1 min)", "Mini photo session: 5 retouched photos"],
          includedTitle: "Included",
          items: ["Creative brief", "Video shoot or photo session", "Professional editing or photo retouching", "Music, text and transitions", "1 round of revisions", "Delivery of ready-to-use content"],
        },
        {
          subtitle: "Content that brings your identity to life.",
          startPrice: "From €700",
          choiceTitle: "Your choice",
          choices: ["4 video Reels (up to 1 min each)", "2 video Reels (up to 1 min) + 10 retouched photos", "Photo session: 20 retouched photos"],
          includedTitle: "Included",
          items: ["Creative brief and creative direction", "Video shoot and/or photo session", "Video editing and photo retouching", "Harmonisation with your brand identity", "1 round of revisions", "Delivery of ready-to-use content"],
        },
        {
          subtitle: "A collection of content to assert your world.",
          startPrice: "From €1,390",
          choiceTitle: "Your choice",
          choices: ["8 video Reels (up to 1 min 30 each)", "4 video Reels + 20 retouched photos", "Mixed photo & video production, defined on quotation"],
          includedTitle: "Included",
          items: ["Strategic discussion and art direction", "Shooting session and/or photo session", "Video editing and photo retouching", "Aesthetic consistency with your world", "2 rounds of revisions", "Delivery of all content"],
        },
        {
          subtitle: "A production designed around your ambitions.",
          startPrice: "On quotation",
          choiceTitle: "Possible services",
          options: ["Promotional and advertising videos", "Professional photo shoots", "Photo and video event coverage", "Launch campaigns", "Regular content creation"],
          includedTitle: "Included depending on the project",
          items: ["Personalised art direction", "Organisation of shoots and photo sessions", "Photo and/or video production", "Editing and post-production", "3 rounds of revisions"],
        },
      ],
    },
  },
  es: {
    offres: {
      subtitle: "Cuatro especialidades complementarias, declinadas en varios niveles de acompañamiento, para construir, valorizar y hacer brillar su marca.",
      customNote: "Porque cada proyecto es único, nuestras firmas pueden adaptarse a sus necesidades. También puede diseñarse un acompañamiento personalizado bajo presupuesto, según sus objetivos y la complejidad de su proyecto.",
    },
    categories: {
      branding: { label: "Identidad visual y Branding", desc: "Logotipo, paleta, tipografía: una identidad que le represente." },
      print: { label: "Creación Print y Soportes de comunicación", desc: "Flyers, tarjetas, carteles, documentos y presentaciones: sus soportes, pensados para su marca." },
      contenu: { label: "Creación de contenido", desc: "Creaciones de foto y vídeo pensadas para contar su historia, capturar su universo y realzar su imagen." },
      "reseaux-sociaux": { label: "Social Media Management", desc: "Estrategia editorial, gestión, planificación, publicación y seguimiento del rendimiento de sus redes sociales." },
    },
    documentsTitle: "Documentos y presentaciones",
    contenu: {
      or: "o",
      disclaimer: "Cada oferta puede adaptarse a sus necesidades. Las tarifas se indican a partir de y pueden variar según la complejidad de la producción.",
      cta: "Solicitar un presupuesto personalizado",
      signatures: [
        {
          subtitle: "Un instante capturado, una historia contada.",
          startPrice: "Desde 300 €",
          choiceTitle: "A elegir",
          choices: ["1 Reel de vídeo (1 min máx.)", "Mini sesión de fotos: 5 fotos retocadas"],
          includedTitle: "Incluido",
          items: ["Brief creativo", "Rodaje de vídeo o sesión de fotos", "Montaje profesional o retoque fotográfico", "Música, textos y transiciones", "1 ronda de modificaciones", "Entrega de contenidos listos para usar"],
        },
        {
          subtitle: "Contenidos que dan vida a su identidad.",
          startPrice: "Desde 700 €",
          choiceTitle: "A elegir",
          choices: ["4 Reels de vídeo (1 min máx. cada uno)", "2 Reels de vídeo (1 min máx.) + 10 fotos retocadas", "Sesión de fotos: 20 fotos retocadas"],
          includedTitle: "Incluido",
          items: ["Brief creativo y dirección creativa", "Rodaje y/o sesión de fotos", "Montaje de vídeo y retoque fotográfico", "Armonización con la identidad de la marca", "1 ronda de modificaciones", "Entrega de contenidos listos para usar"],
        },
        {
          subtitle: "Una colección de contenidos para afirmar su universo.",
          startPrice: "Desde 1 390 €",
          choiceTitle: "A elegir",
          choices: ["8 Reels de vídeo (1 min 30 máx. cada uno)", "4 Reels de vídeo + 20 fotos retocadas", "Producción mixta de foto y vídeo, definida bajo presupuesto"],
          includedTitle: "Incluido",
          items: ["Intercambio estratégico y dirección artística", "Sesión de rodaje y/o sesión de fotos", "Montaje de vídeo y retoque fotográfico", "Coherencia estética con su universo", "2 rondas de modificaciones", "Entrega de todos los contenidos"],
        },
        {
          subtitle: "Una producción pensada en torno a sus ambiciones.",
          startPrice: "Bajo presupuesto",
          choiceTitle: "Servicios posibles",
          options: ["Vídeos promocionales y publicitarios", "Sesiones fotográficas profesionales", "Cobertura de foto y vídeo de eventos", "Campañas de lanzamiento", "Creación regular de contenidos"],
          includedTitle: "Incluido según el proyecto",
          items: ["Dirección artística personalizada", "Organización de rodajes y sesiones de fotos", "Producción de foto y/o vídeo", "Montaje y postproducción", "3 rondas de modificaciones"],
        },
      ],
    },
  },
  it: {
    offres: {
      subtitle: "Quattro competenze complementari, declinate in più livelli di accompagnamento, per costruire, valorizzare e far risplendere il suo marchio.",
      customNote: "Perché ogni progetto è unico, le nostre signature possono essere adattate alle sue esigenze. Un accompagnamento personalizzato può inoltre essere ideato su preventivo, in base ai suoi obiettivi e alla complessità del progetto.",
    },
    categories: {
      branding: { label: "Identità visiva e Branding", desc: "Logo, palette, tipografia: un'identità che le somigli." },
      print: { label: "Stampa e Supporti di comunicazione", desc: "Flyer, biglietti, poster, documenti e presentazioni: i suoi supporti, pensati per il suo marchio." },
      contenu: { label: "Creazione di contenuti", desc: "Creazioni foto e video pensate per raccontare la sua storia, catturare il suo universo e valorizzare la sua immagine." },
      "reseaux-sociaux": { label: "Social Media Management", desc: "Strategia editoriale, gestione, pianificazione, pubblicazione e monitoraggio delle performance dei suoi social." },
    },
    documentsTitle: "Documenti e presentazioni",
    contenu: {
      or: "oppure",
      disclaimer: "Ogni offerta può essere adattata alle sue esigenze. Le tariffe sono indicate a partire da e possono variare in base alla complessità della produzione.",
      cta: "Richiedere un preventivo personalizzato",
      signatures: [
        {
          subtitle: "Un istante catturato, una storia raccontata.",
          startPrice: "A partire da 300 €",
          choiceTitle: "A scelta",
          choices: ["1 Reel video (max 1 min)", "Mini sessione fotografica: 5 foto ritoccate"],
          includedTitle: "Incluso",
          items: ["Brief creativo", "Riprese video o sessione fotografica", "Montaggio professionale o ritocco fotografico", "Musica, testi e transizioni", "1 serie di modifiche", "Consegna dei contenuti pronti all'uso"],
        },
        {
          subtitle: "Contenuti che danno vita alla sua identità.",
          startPrice: "A partire da 700 €",
          choiceTitle: "A scelta",
          choices: ["4 Reel video (max 1 min ciascuno)", "2 Reel video (max 1 min) + 10 foto ritoccate", "Sessione fotografica: 20 foto ritoccate"],
          includedTitle: "Incluso",
          items: ["Brief creativo e direzione creativa", "Riprese e/o sessione fotografica", "Montaggio video e ritocco fotografico", "Armonizzazione con l'identità del marchio", "1 serie di modifiche", "Consegna dei contenuti pronti all'uso"],
        },
        {
          subtitle: "Una collezione di contenuti per affermare il suo universo.",
          startPrice: "A partire da 1 390 €",
          choiceTitle: "A scelta",
          choices: ["8 Reel video (max 1 min 30 ciascuno)", "4 Reel video + 20 foto ritoccate", "Produzione mista foto e video, definita su preventivo"],
          includedTitle: "Incluso",
          items: ["Confronto strategico e direzione artistica", "Sessione di riprese e/o sessione fotografica", "Montaggio video e ritocco fotografico", "Coerenza estetica con il suo universo", "2 serie di modifiche", "Consegna di tutti i contenuti"],
        },
        {
          subtitle: "Una produzione ideata intorno alle sue ambizioni.",
          startPrice: "Su preventivo",
          choiceTitle: "Servizi possibili",
          options: ["Video promozionali e pubblicitari", "Shooting fotografici professionali", "Copertura foto e video di eventi", "Campagne di lancio", "Creazione regolare di contenuti"],
          includedTitle: "Incluso in base al progetto",
          items: ["Direzione artistica personalizzata", "Organizzazione di riprese e shooting", "Produzione foto e/o video", "Montaggio e post-produzione", "3 serie di modifiche"],
        },
      ],
    },
  },
};
